import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@ritualco/jutsu'
import { FullWidthPage } from 'components/PageTemplates'
import { useContent } from 'lib/content/react'
import Companies from './Companies'
import People from './People'

type TenantsProps = {
  organizationId: string
  workspaceId: string
}

const Tenants = ({ organizationId, workspaceId }: TenantsProps) => {
  const { formatMessage } = useContent()

  return (
    <FullWidthPage
      heading={formatMessage({ id: 'pmportal.companies.title' })}
      showDivider={false}
    >
      <Tabs variant="line">
        <TabList>
          <Tab>{formatMessage({ id: 'pmportal.companies.companiesTab' })}</Tab>
          <Tab>{formatMessage({ id: 'pmportal.companies.peopleTab' })}</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <Companies
              workspaceId={workspaceId}
              organizationId={organizationId}
            />
          </TabPanel>
          <TabPanel>
            <People workspaceId={workspaceId} organizationId={organizationId} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </FullWidthPage>
  )
}

export default Tenants
